import React from 'react';
import { CheckCircle2Icon, DownloadIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { deliveryItems } from '../../data/content';
export function Delivery() {
  return <section className="w-full bg-cream px-4 py-14" aria-labelledby="entrega" data-id="element-127" data-mp="26rupb9m0ntuv">
      <div className="mx-auto w-full max-w-3xl" data-id="element-128" data-mp="2brfkd8y2fi2b">
        <p className="text-center text-xs font-extrabold uppercase tracking-[0.25em] text-brandred" data-id="element-129" data-mp="2bq4m1one32il">
          Entrega
        </p>
        <h2 id="entrega" className="mt-3 text-center font-display text-2xl font-extrabold leading-tight text-navy sm:text-4xl" data-id="element-130" data-mp="1e1m57c7x6zdn">
          Acceso inmediato en cuanto completes tu compra
        </h2>
        <p className="mt-4 text-center text-[15px] leading-relaxed text-navy/70" data-id="element-131" data-mp="1ssbick4xyok5">
          No tendrás que esperar envíos ni desbloqueos. Podrás descargar
          inmediatamente:
        </p>

        <ul className="mx-auto mt-7 grid max-w-xl gap-2.5" data-id="element-132" data-mp="10c0q4cx8r4aw">
          {deliveryItems.map(item => <li key={item} className="flex items-center gap-3 rounded-2xl border border-navy/10 bg-white px-4 py-3.5" data-id="element-133" data-mp="wkux1ck84rqp">
              <CheckCircle2Icon className="h-5 w-5 shrink-0 text-brandred" aria-hidden="true" data-id="element-134" data-mp="rmtbmkzbsgc2" />
              <span className="text-[15px] font-semibold text-navy" data-id="element-135" data-mp="iu9bfg3dy3p4">{item}</span>
            </li>)}
        </ul>

        <p className="mt-6 flex items-center justify-center gap-2 text-sm font-semibold text-navy/70" data-id="element-136" data-mp="dvo8va0nv7xi">
          <DownloadIcon className="h-4 w-4 text-brandred" aria-hidden="true" data-id="element-137" data-mp="8us835blw1wb" />
          Descarga en PDF para computadora, tablet o teléfono
        </p>

        <div className="mt-8" data-id="element-138" data-mp="3w09g5tobgxnw">
          <CTAButton label="Quiero mi acceso inmediato" data-id="element-139" data-mp="3w11db8xkb3ga" />
        </div>
      </div>
    </section>;
}